export default {
  'menu.FeedbackRecordListPage': '意见反馈列表',
}